"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { MessageSquarePlusIcon } from "lucide-react";

import { useLastAppLocation } from "@/hooks/useLastAppLocation";
import { useConversations } from "@/services/chat";
import { ChatConversationNavItem } from "@/components/chat/ChatConversationNavItem";
import {
  SidebarCollapsibleGroup,
  SidebarContent,
  SidebarHeader,
  SidebarHeaderMenu,
  SidebarHeaderMenuButton,
  SidebarHeaderRow,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuButtonContent,
  SidebarMenuItem,
  SidebarScrollArea,
} from "@gogive/design-system/components/sidebar";

export function ChatNavContent() {
  const backTo = useLastAppLocation();
  const pathname = usePathname() ?? "/";
  const onNewChat = pathname.replace(/\/+$/, "") === "/chat";

  const { conversations, isLoading } = useConversations();

  return (
    <>
      <SidebarHeader>
        <SidebarHeaderRow>
          <SidebarHeaderMenu>
            <SidebarMenuItem>
              <SidebarHeaderMenuButton asChild>
                <Link href={backTo}>
                  <SidebarMenuButtonContent icon="ArrowLeft">
                    Back to app
                  </SidebarMenuButtonContent>
                </Link>
              </SidebarHeaderMenuButton>
            </SidebarMenuItem>
          </SidebarHeaderMenu>
        </SidebarHeaderRow>
      </SidebarHeader>
      <SidebarContent className="min-h-0 flex-1 gap-0 overflow-hidden px-0 py-0">
        <SidebarScrollArea className="px-0">
          <SidebarCollapsibleGroup title="Assistant">
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton asChild isActive={onNewChat}>
                  <Link href="/chat">
                    <MessageSquarePlusIcon
                      className="size-4 shrink-0"
                      data-slot="icon"
                    />
                    <span>New chat</span>
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarCollapsibleGroup>
          <SidebarCollapsibleGroup title="History">
            <SidebarMenu>
              {isLoading ? (
                <SidebarMenuItem>
                  <span className="px-2 py-1.5 text-xs text-muted-foreground">
                    Loading…
                  </span>
                </SidebarMenuItem>
              ) : conversations.length === 0 ? (
                <SidebarMenuItem>
                  <span className="px-2 py-1.5 text-xs text-muted-foreground">
                    No conversations yet
                  </span>
                </SidebarMenuItem>
              ) : (
                conversations.map((conversation) => (
                  <ChatConversationNavItem
                    key={conversation.id}
                    id={conversation.id}
                    title={conversation.title}
                  />
                ))
              )}
            </SidebarMenu>
          </SidebarCollapsibleGroup>
        </SidebarScrollArea>
      </SidebarContent>
    </>
  );
}
